<script>
	let question_box, concept_box;
	let question = '';
	let concept = '';
	let num_hits = 0;
	const apiURL = "https://rest.metonymize.us:8983/solr/gcc-image-text-concepts-lut/query?rows=9&q.op=OR&q=Description_t:";

	let live_concept_list = [];
	let logged_concept_data = new Set();
	let concatenated_concepts = '';

	function randomElement(array) {
			return array[Math.floor(Math.random() * array.length)];
		}
	
	async function handleQuestionKeydown(event) {
		if (event.key === 'Enter') {
			const text = event.target.value;
			if (!text) return;
			//Assign global concept value
			concept = randomElement(text.split(' '));
			concept_box.focus();
			}

		}
	async function handleConceptKeydown(event) {
		if (event.key === 'Enter') {
			const text = event.target.value;
				if (!text) return;
			const active_url = apiURL+text+"~0";
			const response1 = await fetch(active_url);
			//console.log(active_url);
			live_concept_list = await response1.json();
			num_hits = live_concept_list.response.numFound;
			live_concept_list = (live_concept_list.response.docs);
			//console.log(live_concept_list);
			};
		}
	async function log_item_on_click(item) {
			concept = randomElement(item.Labels_t.split(','));
			item["sampled_concept"]=concept;
			logged_concept_data.add(item);
			logged_concept_data = logged_concept_data;
			console.log(logged_concept_data);
			concept_box.focus();
		};
		function export_aggregated_concepts(){
			[ ... logged_concept_data].forEach((_)=>{concatenated_concepts=concatenated_concepts+" "+_.sampled_concept});
			navigator.clipboard.writeText(concatenated_concepts);
			window.open('https://www.google.com/search?q='+concatenated_concepts);
		};
	function copy_on_click(item) {
			navigator.clipboard.writeText(item.Description_t);
			window.open('https://www.google.com/search?q='+item.sampled_concept);
		};
	
	function pay_using_stripe()	{
			window.open('https://3wai.io/pay');
		};
	
	//<input bind:this={question_box} bind:value={question} on:keydown={handleQuestionKeydown} placeholder="enter the seed idea or question">
</script>

<main>

	<h1>PEIRCE UNSTUCK</h1>
	<input bind:this={concept_box} bind:value={concept} on:keydown={handleConceptKeydown} placeholder="concept in focus">

	<h2>Scanning over {num_hits} images ...</h2>
	<p>Images with buttons responsive to focus concept</p>
	{#each live_concept_list as item}
		<button on:click="{() => log_item_on_click(item)}">
			<img src={item.Image_url_s} alt={item.Description_t} width=100> 
		</button>
	{/each}

	<h1>IDEA BOARD</h1>
	<p>Images with concepts logged for processing</p>
	{#each [ ... logged_concept_data] as item2}
		<button on:click="{() => log_item_on_click(item2)}">
		<figure>
			<img src={item2.Image_url_s} alt={item2.Description_t} width=100> 
			<figcaption>{item2.sampled_concept}</figcaption>
		</figure>
		</button>
	{/each}

	<h2>Merge to clipboard and then search</h2>
	<button on:click="{() => export_aggregated_concepts()}">
		<p>⛽ ==> 🚀</p>
	</button>
	<!--
	<h2>Click copies text to clipboard and googles concept</h2>
	{#each [ ... logged_concept_data] as item3}
		<button on:click="{() => copy_on_click(item3)}">
			<h3>{item3.sampled_concept}</h3> 
			<p>{item3.Description_t}</p> 
		</button>
	{/each}
	-->

	<h2>Sign up for customized access</h2>
	<button on:click="{() => pay_using_stripe()}">
		<p>💌 $/Yr</p>
	</button>

</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #FECF04;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
